import { Query, stringify } from '@im-frontend/praxis-api/qs';
import investorPortalClient from './clients/investorPortal';

export function index(params: Query) {
  return investorPortalClient.get(`/signature_recipients?${stringify(params)}`);
}
